import { Component } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Login from "../login";

const ProtactRoute = ({component:Component, requiredCognitoAuth, ...rest}) => {
    const isAuthenticate = useSelector((state)=> state.auth.isAuthenticate);
    const isCognitoAuthenticated = useSelector((state)=> state.auth.isCognitoAuthenticated);
    if(requiredCognitoAuth && !isCognitoAuthenticated)
        return <Navigate to="/cognito-login" replace/>;
    if(!isAuthenticate)
        return <Login {...rest} />;
    return <Component {...rest} />

}
export default ProtactRoute;